import { Button } from '@mui/material'
import React, { useState } from 'react'
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import EditDialog from '../../../Modals/EditMaterialDialog';
import ConfirmDialog from '../../../Modals/ConfirmDialog';
import { useDeleteMaterialMutation, useUpdateMaterialMutation } from '../../../../features/fullApi';
import { Store } from 'react-notifications-component';


const Material = (material) => {

    const [open, setOpen] = useState(false)
    const [openEdit, setOpenEdit] = useState(false)
    const user = JSON.parse(localStorage.getItem('user'))

    const openModalEditItem = ((material) => {
        setOpenEdit(true)
      })
  
      const [updateMaterial] = useUpdateMaterialMutation()
      const [deleteMaterial] = useDeleteMaterialMutation()
    
      const message = "Are you sure you want to delete this material ?";
    
      const openDeleteModal = (() => {
        setOpen(true)
      })
    
      const handleUpdateMaterial = ((material) => {
        setOpenEdit(false)
        updateMaterial({_id: material.id._id, materialName: material.materialName}, { 
          headers: {
            'Token': `Bearer ${user?.accessToken}`
          }
        }).then(
        )
      })
    
    
      const handleDelete = (async (materialId) => {
        deleteMaterial({id: materialId}).then(
        )
        setOpen(false)
      })

  return (
    <>
    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
    {user?.isAdmin && (
        <div style={{display: 'flex', justifyContent: 'center'}}>
            <Button aria-label="Edit Item" onClick={() => openModalEditItem(material.material._id)}>
              <EditIcon style={{color: 'orange'}}/>
            </Button>
            <Button aria-label="Delete product" onClick={() => openDeleteModal(material.material._id)} size="small">
            <DeleteIcon style={{color: 'red'}}/>
            </Button>
        </div>
    )}
    </div>
    <EditDialog openEdit={openEdit} handleUpdateMaterial={handleUpdateMaterial} setOpenEdit={setOpenEdit} item={material.material}>         
    </EditDialog>
    <ConfirmDialog open={open} handleDelete={handleDelete} setOpen={setOpen} item={material.material} message={message}></ConfirmDialog>
  </>
  )
}

export default Material